import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div className="table">
      <table>
        <tr>
          <th className="col bor-bot" />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>is</td>
          <td>ea</td>
          <td>id</td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>eius</td>
          <td>eius</td>
          <td>eius</td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>ei</td>
          <td>ei</td>
          <td>ei</td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>

          <td>eum</td>
          <td>eam</td>
          <td>id</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">eo</td>
          <td className="bor-bot">ea</td>
          <td className="bor-bot">eo</td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>ei</td>
          <td>eae</td>
          <td>ea</td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>eorum</td>
          <td>earum</td>
          <td>eorum</td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>eis</td>
          <td>eis</td>
          <td>eis</td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>eos</td>
          <td>eas</td>
          <td>ea</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. mv.</th>
          <td className="bor-bot">eis</td>
          <td>eis</td>
          <td className="bor-bot">eis</td>
        </tr>
        <tr>
          <th className="col" />
          <td colSpan={3} className="center">
            <i>1. deze, dit, die, dat &nbsp;&nbsp;&nbsp; 2. hij, zij, het</i>
          </td>
        </tr>
      </table>
    </div>

    <p>
      <Letop>
        Dit rijtje lijkt erg op het rijtje van{" "}
        <a href="bijvoeglijk-naamwoord">
          <b>longus</b>
        </a>
        . Alleen de nominativus, genitivus en dativus enkelvoud wijken af.
      </Letop>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/verw-vnw.js